import React from 'react';
import { Cpu } from 'lucide-react';
import { useContent } from '../content/ContentContext';

export default function BrandMark({ size = 'md', className = '' }) {
  const { site = {} } = useContent();
  const logoUrl = site.logoUrl || '';
  const sizes = {
    sm: 'h-8 w-8 rounded-lg',
    md: 'h-9 w-9 rounded-xl',
    lg: 'h-10 w-10 rounded-xl',
  };
  const iconSizes = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-5 w-5',
  };

  if (logoUrl) {
    return (
      <span className={`${sizes[size] || sizes.md} inline-flex shrink-0 items-center justify-center overflow-hidden bg-white ring-1 ring-gray-200 ${className}`}>
        <img src={logoUrl} alt={site.brandName || 'Logo'} className="h-full w-full object-contain" />
      </span>
    );
  }

  return (
    <span className={`${sizes[size] || sizes.md} inline-flex shrink-0 items-center justify-center bg-gradient-to-tr from-blue-600 to-blue-500 text-white ${className}`}>
      <Cpu className={iconSizes[size] || iconSizes.md} />
    </span>
  );
}
